function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { bool, elementType, string } from 'prop-types';
import clsx from 'clsx';
import { styled } from '@mui/material/styles';
import { square } from '../../../internals/utils/stylesHelpers';
var BaseIcon = function BaseIcon(_ref) {
  var className = _ref.className,
    element = _ref.element,
    isVisible = _ref.isVisible;
  var StyledElement = styled(element)(function (_ref2) {
    var _ref2$theme = _ref2.theme,
      palette = _ref2$theme.palette,
      spacing = _ref2$theme.spacing,
      transitions = _ref2$theme.transitions;
    return _objectSpread(_objectSpread({
      pointerEvents: 'none',
      color: palette.primary.contrastText,
      opacity: 0,
      position: 'absolute',
      transition: "all ".concat(transitions.duration.short, "ms")
    }, square(spacing(3))), {}, {
      '&.sovosNavigation__productIcon--visible': {
        opacity: 1
      }
    });
  });
  return /*#__PURE__*/React.createElement(StyledElement, {
    className: clsx(className, 'sovosNavigation__productIcon', isVisible && 'sovosNavigation__productIcon--visible')
  });
};
BaseIcon.propTypes = {
  className: string,
  element: elementType.isRequired,
  isVisible: bool.isRequired
};
BaseIcon.defaultProps = {
  className: undefined
};
export default BaseIcon;